import { Component, AfterViewInit } from '@angular/core';
import { LoadingService } from './services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { GeneralService } from './services/general.service';
import { UserService } from 'src/app/services/user.service';
import { ThemeService } from './services/theme.service';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

const PUBLIC_ROUTES = ['/login', '/actPass', '/RecoverPasswordCS', '/createuser'];

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements AfterViewInit {
  theme$: Observable<string>;
  // el loader se lee un tick despues: el interceptor lo prende de forma sincronica y, si una
  // pantalla consulta en su ngOnInit (dentro de la deteccion de cambios), el binding cambiaba
  // despues de revisado → NG0100 en desarrollo
  isLoading$: Observable<boolean>;
  showNavbar = false;
  title = 'ng-uikit-pro-standard';
  isNavCollapse = false;
  visibleNav: boolean;
  userMenu: any;
  onlySubMenu: any;

  constructor(
    public loadingService: LoadingService,
    translate: TranslateService,
    private router: Router,
    private ThemeService: ThemeService,
    private generalService: GeneralService,
    public userService: UserService) {
    translate.setDefaultLang('en');

    this.theme$ = this.ThemeService.theme$;
    this.isLoading$ = this.loadingService.isLoading.pipe(delay(0));

    this.generalService.currentUrl.next(this.router.url);

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.generalService.previousUrl.next(this.generalService.currentUrl.value);
        this.generalService.currentUrl.next(event.url);
        this.showNavbar = !PUBLIC_ROUTES.some(p => event.urlAfterRedirects.startsWith(p));
      }
    });
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   console.log('windowwwww', event);
  //   // this.innerWidth = window.innerWidth;
  // }


  ngAfterViewInit() {

    // var mythis = this;
    // const menu = localStorage.getItem('userMenu');
    // if (!menu) {
    //   mythis.userService.getMenu().subscribe((data) => {
    //     localStorage.setItem('userMenu', JSON.stringify(data));
    //     mythis.loadMenu();
    //   });
    // }
    // else {
    //   mythis.loadMenu();
    // }

  }

  loadMenu() {

    // var mythis = this

    // this.onlySubMenu = [];
    // this.userMenu = JSON.parse(localStorage.getItem('userMenu'));
    // this.userMenu.userMenuNodes.forEach(function (element) {
    //   element.userModules.forEach(function (element2) {
    //     if (element2.mobile == 1) {
    //       mythis.onlySubMenu.push(element2);
    //     }
    //   });
    // });


  }

}
